export const conditionsMatchingUserAnswers = (conditions, answers) => {
  let allConditionsMatched = true;

  for (let i = 0; i < conditions.length && allConditionsMatched; i++) {
    const condition = conditions[i];
    if (condition.negation) {
      if (answers[condition.key] && (condition.values || []).includes(answers[condition.key])) {
        allConditionsMatched = false;
      }
    } else {
      if (answers[condition.key] == null || !(condition.values || []).includes(answers[condition.key])) {
        allConditionsMatched = false;
      }
    }
  }

  return allConditionsMatched;
};

export const disjunctionConditionsMatchingUserAnswers = (conditions, answers) => {

  if (conditions.length === 0) {
    return true;
  }

  let anyMatch = false;
  for (let i = 0; i < conditions.length && !anyMatch; i++) {
    anyMatch = anyMatch || conditionsMatchingUserAnswers((conditions[i].disjunctions || []), answers);
  }

  return anyMatch;
};

export const answerIsActive = (answer, userAnswers) => {
  return disjunctionConditionsMatchingUserAnswers(answer.activeIf || [], userAnswers);
};

export const questionIsActive = (question, userAnswers) => {
  let isActive = disjunctionConditionsMatchingUserAnswers(question.activeIf || [], userAnswers);
  let atLeastOneAnswerActive = false;

  for (let i = 0; i < question.answers.length && !atLeastOneAnswerActive; i++) {
    if (answerIsActive(question.answers[i], userAnswers)) {
      atLeastOneAnswerActive = true;
    }
  }

  return isActive && atLeastOneAnswerActive;
};
